import React from 'react';
import { usePlace } from '../../nucleus/place';
import NodesPage from './NodesPage';
import ReviewPage from './ReviewPage';
import SchemasPage from './SchemasPage';
import TrashPage from './TrashPage';
// the sheets this section re-hosts (filter, editor, relate, history…) wear the
// graph's sheet styles; the section's own sit beside it
import '../nucleus/GraphPage.css';
import './GraphSection.css';

// GRAPH — this is my graph. Its nodes (narrowed by kind, saved view, filter
// and search), what waits for review before it goes in, the kinds a node comes
// in (schemas), and the trash. In a group, the group's graph.
export default function GraphSection() {
    const { page } = usePlace();
    if (page?.id === 'review') return <ReviewPage />;
    if (page?.id === 'schemas') return <SchemasPage />;
    if (page?.id === 'trash') return <TrashPage />;
    return <NodesPage />;
}
